import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { MatSidenavModule } from '@angular/material/sidenav';
import { ChatDrawerComponent } from './components/chat-drawer/chat-drawer.component';
import { ChatBotComponent } from './components/chatbot/chatbot.component';

@NgModule({
  declarations: [ChatBotComponent, ChatDrawerComponent],
  imports: [CommonModule, MatIconModule, MatSidenavModule, FormsModule],
  exports: [ChatBotComponent, ChatDrawerComponent],
})
export class HiveGptModule {}
